import { useFlags } from "launchdarkly-react-client-sdk";

/**
 * Single source of truth for whether the Interview Guides feature is on.
 *
 * **Default OFF** — enabled only when the LaunchDarkly `interviewGuides` flag is
 * explicitly `true`. An unset/unknown flag (no LD value, offline, pre-init) is
 * treated as off, so the in-development feature never leaks into an environment
 * that hasn't deliberately turned it on. Enable per environment via LaunchDarkly
 * targeting (the provider sends an `environment` custom attribute).
 *
 * Used by the routes (App.tsx), the nav links (AdminNav), and the per-page
 * guards so all three gate consistently.
 */
export function useInterviewGuidesEnabled(): boolean {
  const { interviewGuides } = useFlags();
  return interviewGuides === true;
}
